//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Vue from 'vue';
import { DatePickerPlugin } from '@syncfusion/ej2-vue-calendars';
import axios from 'axios';
Vue.use(DatePickerPlugin);
export default {
    props: ['eventid', 'title', 'message', 'setdate', 'userdate', 'eventindex', 'buttonlabel', 'disableplanner'],
    methods:{
        onFocus: function(args){
            // console.log(this.message);
            this.$refs.dateObj.show();
        },
        onOpen: function (event) { 
            var btn = document.getElementById(this.eventindex); 
            event.popup.relateTo = btn; 
            event.popup.offsetX = 0; 
            event.popup.offsetY = -440; 
            event.popup.dataBind(); 
            event.popup.refreshPosition(btn, true); 
        },
        onClose: function(args){
            // console.log('here');
        },
        onChange: function(args){
            this.dateval = new Date(this.setdate);
            let v = this;
            var data = new FormData();

           if (args.event) {
               if (args.event.target) {
                data.append('selected_date', args.event.target.title);
                data.append('event', this.eventid);
                data.append('title', this.title);
                data.append('action', 'setuserevent');
                this.notice = '<h4>Added to planner!</h4>';
                this.thebuttonlabel = 'Added to Planner';

                axios
                    .post(ajax_object.ajax_url, data)
                    .then(response => {
                        this.dateval = new Date(this.setdate);
                        setTimeout(function() {
                            v.notice = '';
                        }, 2000);
                    });
               }
           }

        },
    },
    data () {
        return{
            notice: '',
            thebuttonlabel: this.buttonlabel,
            dateval: new Date(this.setdate),
            userdateval: new Date(this.userdate),
            value: 1,
        }
    },
}



// WEBPACK FOOTER //
// ./scripts/Eventaddtoplanner.vue